import ___default from "lodash";
import { createSelector } from "reselect";
import { convertFeature } from "../../../Common/utils/FeatureListUtils.js";
import { getDefaultAsyncWrapperObj } from "@ane/core/lib/models";
const selectFeatureSearchContext = (state) => state.experimentSearchModule.featureSearchV3.context;
const selectFeatures = (state) => state.experimentSearchModule.featureSearchV3.items;
const selectUserAffinity = (state) => state.currentUserDetails.userAffinity;
const selectExperimentationGroupsAsync = (state, workspaceId) => {
  var _a;
  return (_a = state.experimentSearchModule.featureSearchV3.experimentationGroups[workspaceId]) != null ? _a : getDefaultAsyncWrapperObj();
};
const selectConvertedFeatures = createSelector(
  selectFeatures,
  (featuresAsync) => featuresAsync && ___default.map(featuresAsync.data, (f) => convertFeature(f)) || []
);
export {
  selectConvertedFeatures,
  selectExperimentationGroupsAsync,
  selectFeatureSearchContext,
  selectFeatures,
  selectUserAffinity
};
//# sourceMappingURL=selectors.js.map
